import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { PuzzleItem } from './data';
import { debounceTime, fromEvent, take, takeUntil, throttleTime } from 'rxjs';
import { HttpClientModule } from '@angular/common/http';
import { JsonDataService } from '../../../../services/json-data/json-data.service';
import { SignialsService } from '../../../../services/signals/signials.service';
import { CloseButtonService } from '../../../../services/close-button.service';
import { BackgropComponent } from '../../../ui/base/backgrop/backgrop.component';
import { CommonModule } from '@angular/common';
import { GameUiService } from '../../../../services/game-ui/game-ui.service';
import { GameContext } from '../../../../services/game-ui/game-context.enum';
import { AudioService } from '../../../../services/audio/audio.service';

interface PuzzlePart {
  name: number;
  selected: boolean;
  correctlyPosition: boolean;
}
@Component({
  selector: 'app-puzzle',
  providers: [
    JsonDataService,
  ],
  templateUrl: './puzzle.component.html',
  styleUrl: './puzzle.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PuzzleComponent implements OnInit, OnDestroy {
	@Output()
	closeModal: EventEmitter<void> = new EventEmitter();
	@Output()
	showPhrase: EventEmitter<string> = new EventEmitter();
  @Output()
  showNewPhrase: EventEmitter<{text: string, sound: string}> = new EventEmitter();
  puzzleInfo: PuzzleItem;

  puzzleParts: PuzzlePart[] = [];
  partsCount = 9;
  math = Math;

  firstPart?: PuzzlePart;

  images = [1, 3, 8, 11, 12];
  currentImage: number;

  win = false;
  showStartButton= false;
  subs;

  itemSubscription;

  selectedElement: HTMLElement | null;
  selectedItem: PuzzlePart | null;
  selectedIndex: number | null;
  leavedIndex: number | null;

  showGame = true;
  gender: string;
  constructor(
    private signal: SignialsService,
    private sound: AudioService,
    private cdr: ChangeDetectorRef,
		private jsonData: JsonDataService,
    private ui: GameUiService,
  ) {}
  ngOnInit(): void {

    this.gender = localStorage.getItem('gender') || '';
		this.subs = this.ui.skipClicked$.subscribe(() => {
      // console.log('close');
      this.close();
		});
    
    this.shuffle(this.images);
    this.shuffle(this.images);
    this.currentImage = this.images[0];

		this.jsonData.loadJson<PuzzleItem>(`puzzle/${this.images[0]}`).subscribe(data => {
			this.puzzleInfo = data;
      this.start();
		});
    for (let i = 1; i <= this.partsCount; i++) {
      this.puzzleParts.push({
        name: i,
        selected: false,
        correctlyPosition: false,
      });
    }
    this.shuffle(this.puzzleParts);
    this.shuffle(this.puzzleParts);
    this.checkPartsPositions();
    if (this.isWin()) {
      setTimeout(() => {
        this.win = true;
        this.cdr.detectChanges();
      }, 200);
      setTimeout(() => {
        this.showGame = false;
        this.signal.dialogEnded.pipe(take(1)).subscribe(() => {
          this.nextStep();
        });
        this.showNewPhrase.emit({text: this.puzzleInfo.before, sound: `dialogs/rat/${this.puzzleInfo.sound}`});
        this.cdr.detectChanges();
      }, 3000)
    }

    
    const move = fromEvent<PointerEvent>(window, 'pointermove').pipe(throttleTime(1000 / 60)).subscribe(e => {
      if (this.selectedElement && e.target && this.selectedElement != e.target) {
        // this.selectedElement.style.position = 'fixed';
        // this.selectedElement.style.left = e.layerX + 'px';
        // this.selectedElement.style.top = e.layerY + 'px';

      }
    });
  }

  ngOnDestroy(): void {

    this.ui.setContext(GameContext.None);
    this.subs.unsubscribe();
  }

  playSwipe() {
    this.sound.playSfx('Cell_move');
  }
  playWin() {
    // this.sound.playSfx('Picture_done');
    this.sound.playWinGame();
  }
  
  trackByItemId(index: number, tile: PuzzlePart): string | number {
    return tile.name;
  }

  getTileClass(index: number): string {
    const row = Math.floor((index-1) / 3);
    const col = (index-1) % 3;
    return `tile-${row}-${col} ${this.gender}-${this.currentImage}`;
  }

  checkWin() {
    let isWin = true;
    this.puzzleParts.forEach((item, index) => {
      if (item.name != index + 1) {
        isWin = false;
      }
    });
    setTimeout(() => {
      this.win = isWin;
      this.cdr.detectChanges();
      if (isWin) this.playWin();
    }, 200);
    if (isWin) {
      setTimeout(() => {
        this.showGame = false;

        this.signal.dialogEnded.pipe(take(1)).subscribe(() => {
          this.nextStep();
        });
        this.showNewPhrase.emit({text: this.puzzleInfo.before, sound: `./assets-compressed/sounds/dialogs/rat/${this.puzzleInfo.sound}`});
        this.cdr.detectChanges();
      }, 2500);
    }
  }

  shuffle(array: PuzzlePart[] | number[]) {
    array.sort(() => Math.random() - 0.5);
  }

  swapParts(index1: number, index2: number) {
    this.playSwipe();
    [this.puzzleParts[index1], this.puzzleParts[index2]] = [
      this.puzzleParts[index2],
      this.puzzleParts[index1]
    ];
    this.cdr.detectChanges();
    this.checkWin();
  }
  takePart(event: PointerEvent, item: PuzzlePart) {
    event.preventDefault();
    this.selectedIndex = this.puzzleParts.indexOf(item);
    if (this.selectedIndex === -1) return;

    const startX = event.clientX;
    const startY = event.clientY;

    const move$ = fromEvent<PointerEvent>(window, 'pointermove');
    const up$ = fromEvent<PointerEvent>(window, 'pointerup');

    const sub = move$.pipe(takeUntil(up$)).subscribe(moveEvent => {
      const dx = moveEvent.clientX - startX;
      const dy = moveEvent.clientY - startY;
      const SWIPE_THRESHOLD = 40;

      if (Math.abs(dx) < SWIPE_THRESHOLD && Math.abs(dy) < SWIPE_THRESHOLD) return;

      let targetIndex: number | null = null;

      // горизонтальные свайпы
      if (Math.abs(dx) > Math.abs(dy)) {
        if (dx > 0 && (this.selectedIndex! + 1) % 3 !== 0) {
          targetIndex = this.selectedIndex! + 1; // вправо
        } else if (dx < 0 && this.selectedIndex! % 3 !== 0) {
          targetIndex = this.selectedIndex! - 1; // влево
        }
      } 
      // вертикальные свайпы
      else {
        if (dy > 0 && this.selectedIndex! + 3 < this.puzzleParts.length) {
          targetIndex = this.selectedIndex! + 3; // вниз
        } else if (dy < 0 && this.selectedIndex! - 3 >= 0) {
          targetIndex = this.selectedIndex! - 3; // вверх
        }
      }

      if (targetIndex !== null) {
        this.swapParts(this.selectedIndex!, targetIndex);
        sub.unsubscribe(); // отписываемся, чтобы не было хаоса
      }
    });
  }

  checkPartsPositions() {
    this.puzzleParts.forEach(part => {
      part.correctlyPosition = (part.name - 1) == this.puzzleParts.indexOf(part);
    });
  }

  isWin() {
    return this.puzzleParts.every(p => p.correctlyPosition);
  }

  close() {
    this.signal.completedPipeGame$.next(true);
    this.closeModal.emit();
  }

  showNextButton() {
    this.showStartButton = true;
    this.cdr.detectChanges();
  }
  start() {
    this.showStartButton = false;
    this.cdr.detectChanges();
  }
  nextStep() {
    this.finish();
  }
  finish() {
    this.showGame = false;
    this.showPhrase.emit('end');
    
    this.signal.dialogEnded.pipe(take(1)).subscribe(() => {
      // this.closeModal.emit();
      // console.log('end');

      this.close();
    });
  }
}
